module.exports = __webpack_public_path__ + "static/media/9DESA21.a771c31b.jpg";